import 'jq-accordion/dist/js/jquery.accordion.min';
import contestScroll from './contest_scroll';

const $accordion = function($container, $target) {
  const container = $container || $('@body');
  const $accordion = container.find($target);
  const $window = $(window);

  function init(config) {
    $accordion.accordion(config);
    contestScroll();
    $(window).on('click', () => {
      $window.trigger('resize');
    });
  }

  if ($accordion.length > 0) {
    const config = {
      transitionSpeed: 300,
      singleOpen: false,
    };

    init(config);
  }
};

export default $accordion;

